import { Event } from '../api/events/Event';
const googleAnalyticsIds: string[] = [];

export function addGoogleAnalyticsId(id: string): void {
    if (!googleAnalyticsIds.includes(id)) {
        googleAnalyticsIds.push(id);
    }
}

function mapEventParameters(event: CustomEvent<Event>) {
    const detail = event.detail as Event;
    const parameters: {
        products?: string[];
        details?: string;
        search_details?: string;
        source?: 'brilliant' | 'web';
        source_details?: 'ui' | 'chat';
        isInteraction: boolean;
    } = {
        source: detail.source,
        isInteraction: detail.isInteraction
    };
    if (detail.source === 'brilliant') {
        parameters.source_details = detail.brilliantSource;
    }
    switch (detail.type) {
        case 'bri.view_active_help':
        case 'bri.click_active_help':
        case 'bri.close_active_help':
            parameters.details =
                detail.scenarioName + detail.actionName
                    ? ` (${detail.actionName})`
                    : '';
            break;
        case 'bri.click_add_product_to_cart':
            parameters.products = [detail.productId];
            break;
        case 'bri.open_add_many_products_to_cart':
            parameters.products = detail.productIds;
            break;
        case 'bri.input_chat':
            parameters.details = detail.inputValue;
            break;
        case 'bri.change_comparing_products':
        case 'bri.open_comparison':
            parameters.products = detail.productIds;
            break;
        case 'bri.click_product_card':
            parameters.products = [detail.productId];
            break;
        case 'bri.click_product_card_action':
            parameters.products = [detail.productId];
            parameters.details = detail.action;
            break;
        case 'bri.change_search_result_filter':
            parameters.details = detail.searchType;
            parameters.search_details = `Sort by: ${detail.sortBy}, Min price: ${detail.minPrice}, Max price: ${detail.maxPrice}, Taxonomy tags: ${detail.taxonomyTags.join(', ')}`;
            break;
        case 'bri.start_search':
        case 'bri.open_search_result':
            parameters.details = detail.searchType;
            switch (detail.searchType) {
                case 'product-search-new':
                    parameters.search_details = '';
                    break;
                case 'product-search-by-text':
                    parameters.search_details = detail.searchText;
                    break;
                case 'product-search-similar':
                case 'product-search-combinations':
                    parameters.search_details =
                        detail.searchBaseProductIds.join(', ');
                    break;
                case 'product-search-complementary-category':
                    parameters.search_details = detail.categoryValue;
                    break;
                case 'product-search-similar-by-image':
                case 'product-search-combinations-by-image':
                    parameters.search_details = detail.searchImageUrl;
                    break;
            }
            if (detail.type === 'bri.open_search_result') {
                parameters.products = detail.productIds;
            }
            break;
        case 'bri.click_widget_item':
            parameters.details = detail.itemId;
            break;
        case 'bri.upload_image':
            parameters.details = detail.fileUrl;
            break;
        case 'bri.click_suggested_question':
            parameters.products = detail.productIds;
            break;
        case 'bri.view_product_detail':
            parameters.products = [detail.productId];
            break;
    }

    return parameters;
}

type GoogleAnalyticsEventCategory =
    | 'active_help'
    | 'cart'
    | 'chat'
    | 'default'
    | 'compare'
    | 'product'
    | 'promotion'
    | 'search'
    | 'widget';
if (ENABLE_EVENTS_GOOGLE_ANALYTICS) {
    const eventTypes: Record<Event['type'], GoogleAnalyticsEventCategory> = {
        'bri.click_add_product_to_cart': 'cart',
        'bri.change_comparing_products': 'compare',
        'bri.change_search_result_filter': 'search',
        'bri.click_active_help': 'active_help',
        'bri.click_go_to_cart': 'cart',
        'bri.click_product_card_action': 'product',
        'bri.click_product_card': 'promotion',
        'bri.click_view_more_products': 'promotion',
        'bri.close_active_help': 'active_help',
        'bri.init_success': 'default',
        'bri.show_main_button': 'default',
        'bri.start_search': 'search',
        'bri.input_chat': 'chat',
        'bri.open_comparison': 'compare',
        'bri.open_search_result': 'search',
        'bri.open_add_many_products_to_cart': 'promotion',
        'bri.view_active_help': 'active_help',
        'bri.view_product_detail': 'product',
        'bri.click_widget_item': 'widget',
        'bri.close_widget': 'widget',
        'bri.close_main_window': 'default',
        'bri.open_widget': 'widget',
        'bri.upload_image': 'widget',
        'bri.click_suggested_question': 'chat'
    };
    for (const eventType of Object.keys(eventTypes)) {
        document.addEventListener(eventType, event => {
            if ('gtag' in window && typeof window.gtag === 'function') {
                const { detail } = event as CustomEvent<Event>;
                window.gtag('event', detail.type, {
                    ...mapEventParameters(event as CustomEvent<Event>),
                    event_category: 'brilliant',
                    category: eventTypes[detail.type],
                    send_to: googleAnalyticsIds
                });
            }
        });
    }
}
